export interface BaseErrorObject<T extends string = string> {
  detail: T;
  status: number;
  title: string;
}

export interface BaseErrorParams<T extends string = string> {
  error: BaseErrorObject<T>;
}

export class BaseError<T extends string = string> extends Error {
  public detail: T;
  public status: number;
  public title: string;

  constructor({ detail, status, title }: BaseErrorObject<T>) {
    super(detail);
    this.detail = detail;
    this.status = status;
    this.title = title;
  }
}

export const isBaseErrorParams = <T extends string>(obj: any, enumType?: object): obj is BaseErrorObject<T> =>
  typeof obj === "object" &&
  "status" in obj &&
  typeof obj.status === "number" &&
  "title" in obj &&
  typeof obj.title === "string" &&
  "detail" in obj &&
  (enumType ? Object.values(enumType).includes(obj.detail) : typeof obj.detail === "string");

export const resolveBaseErrorParams = <T extends string>(objRaw: any, enumType?: object): BaseErrorObject<T> | null => {
  let obj = objRaw;

  if ("error" in objRaw) {
    obj = objRaw.error;
  }

  if (isBaseErrorParams<T>(obj, enumType)) {
    return obj;
  }

  return null;
};
